// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TwitterCircleFilledSvg from "@ant-design/icons-svg/es/asn/TwitterCircleFilled";
import AntdIcon from '../components/AntdIcon';

var TwitterCircleFilled = function TwitterCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TwitterCircleFilledSvg
  }));
};

TwitterCircleFilled.displayName = 'TwitterCircleFilled';
export default React.forwardRef(TwitterCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TwitterCircleFilled.js
// module id = 1965
// module chunks = 0